package io.horion.cv.components.widgets

fun exec(command: String) {
    js("document.execCommand(command, false, null)")
}